// extracted by mini-css-extract-plugin
var _1 = "SoldBundlesTableColumns_bundleCell__UKo4j";
var _2 = "SoldBundlesTableColumns_clientCell__n3O8Z";
var _3 = "SoldBundlesTableColumns_serviceCell__kMin3";
export { _1 as "bundleCell", _2 as "clientCell", _3 as "serviceCell" }
